import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Stack, ButtonBaseActions, List } from "@mui/material";
import { DeleteRounded } from "@mui/icons-material";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { ContentItem } from "../../../../../../shell/services/types";
import { DialogContentItem } from "./DialogContentItem";
type ConfirmDeletesModalProps = {
  items: ContentItem[];
  onConfirm: (items: ContentItem[]) => void;
  onCancel: () => void;
  loading: boolean;
};
export const ConfirmDeletesDialog = ({
  items,
  onConfirm,
  onCancel,
  loading
}: ConfirmDeletesModalProps) => {
  const {
    t
  } = useTranslation();
  const actionRef = useRef<ButtonBaseActions | null>(null);
  const onEntered = () => actionRef?.current?.focusVisible();
  return <Dialog open data-cy="ConfirmPublishModal" PaperProps={{
    sx: {
      width: 480
    }
  }} TransitionProps={{
    onEntered
  }} data-sentry-element="Dialog" data-sentry-component="ConfirmDeletesDialog" data-sentry-source-file="ConfirmDeletesDialog.tsx">
      <DialogTitle component="div" sx={{
      pb: 1
    }} data-sentry-element="DialogTitle" data-sentry-source-file="ConfirmDeletesDialog.tsx">
        <Stack height={40} width={40} bgcolor="red.100" borderRadius="50%" justifyContent="center" alignItems="center" marginBottom={1.5} data-sentry-element="Stack" data-sentry-source-file="ConfirmDeletesDialog.tsx">
          <DeleteRounded color="error" data-sentry-element="DeleteRounded" data-sentry-source-file="ConfirmDeletesDialog.tsx" />
        </Stack>
        <Box data-sentry-element="Box" data-sentry-source-file="ConfirmDeletesDialog.tsx">
          {t("content.itemListDeleteTitle", {
          count: items.length
        })}
          {":"}
        </Box>
        <Typography variant="body2" color="text.secondary" mt={1} data-sentry-element="Typography" data-sentry-source-file="ConfirmDeletesDialog.tsx">
          {t("content.itemListDeleteDescription", {
          count: items.length
        })}
        </Typography>
      </DialogTitle>
      <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="ConfirmDeletesDialog.tsx">
        <List disablePadding data-sentry-element="List" data-sentry-source-file="ConfirmDeletesDialog.tsx">
          {items.map((item, index) => <DialogContentItem key={index} item={item} />)}
        </List>
      </DialogContent>
      <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="ConfirmDeletesDialog.tsx">
        <Button variant="text" color="inherit" onClick={() => onCancel()} data-sentry-element="Button" data-sentry-source-file="ConfirmDeletesDialog.tsx">
          {t("common.cancel")}
        </Button>
        <Button loading={loading} data-cy="ConfirmMultiPageTableDelete" action={actions => actionRef.current = actions} variant="contained" color="error" onClick={() => {
        onConfirm(items);
      }} data-sentry-element="Button" data-sentry-source-file="ConfirmDeletesDialog.tsx">
          {t("content.itemListDeleteButton", {
          count: items.length
        })}
        </Button>
      </DialogActions>
    </Dialog>;
};